// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4415":"3aae225d","7795":"c55d9fcb","8015":"16c3c7cc"}[chunkId] + ".chunk.css";
};